import { Briefcase, History, User as UserIcon } from 'lucide-react';
import type { SectionKey } from '../types/user';

interface UserTabNavigationProps {
  activeSection: SectionKey;
  onSectionChange: (section: SectionKey) => void;
}

const sections = [
  { key: 'personal' as SectionKey, label: 'Personal', icon: UserIcon },
  { key: 'job' as SectionKey, label: 'Job Info', icon: Briefcase },
  { key: 'log' as SectionKey, label: 'Log', icon: History },
];

export function UserTabNavigation({ activeSection, onSectionChange }: UserTabNavigationProps) {
  return (
    <div className="py-4 bg-white dark:bg-gray-950">
      <div className="flex items-center gap-2 border border-border rounded-lg p-1.5 overflow-x-auto">
        {sections.map((section) => {
          const Icon = section.icon;
          const isActive = activeSection === section.key;
          return (
            <button
              key={section.key}
              onClick={() => onSectionChange(section.key)}
              className={`px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200 flex items-center gap-2 whitespace-nowrap ${
                isActive
                  ? 'bg-orange-600 text-white'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              }`}
            >
              <Icon className="w-4 h-4" />
              {section.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
